<template>
  <div class="mpQQ-upload-temp">
    <!-- api/cloud_company_reg_mini_pro_up_idcard -->
    <upfile name="上传临时素材" :many="1" action='api/ysy_common_upfile_with_judge' :mul="false" bus='abcde'
      acc=".jpeg,.jpg,.png,.gif,.mp3,.mp4,.xls,.xlsx,.doc,.docx,.ppt,.txt,.xml,.tar,.wps,.zip,.pdf,.pptx" :acce="['img','voice','video','excel','doc','ppt','text','tar','wps','zip','pdf']" />
  </div>
</template>

<script>
import upfile from '../../common/UpFile.vue'
export default {
  name: 'mpQQUploadTemp',
  components: { upfile },
  data() {
    return {
      des: ''
    }
  },
  mounted () {
    this.des = this.$route.query.des
    console.log(this.des)
    this.$axios.get('https://cha.qiyehuo.com/api/client/wxlogin/wxlogincallback').then(() =>{})
  }
}
</script>

<style scoped>
.mpQQ-upload-temp {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/ysy/mpQQUpLoadTemp.vue